import * as React from 'react';

import { ModalFrame, ModalFrameInner } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

applyTranslations(require('./form-field-modal.i18n.json'));

type Props = {
  formFieldModalKey: string
};

const msgKey = 'form_field_modal';

const FormFieldModal = (
  {
    formFieldModalKey
  }: Props
): JSX.Element => (
  <ModalFrame>
    <ModalFrameInner>
      <div
        className="form-field-modal"
        dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(__t(`${msgKey}.messages.${formFieldModalKey}`)) }}
      />
    </ModalFrameInner>
  </ModalFrame>
);

export default FormFieldModal;
